import React, { useState, useEffect } from "react";
import "../Home/home.scss";
import MaskImg from "../../Assets/Images/admin-graph-main.png";
import MaskImgPhone from "../../Assets/Images/mask-group-2.png";
import Star from "../../Assets/Images/star.png";
import Secure from "../../Assets/Images/secure.png";
import Support from "../../Assets/Images/support.png";
import ReImg from "../../Assets/Images/proton.png";
import Android from "../../Assets/Images/android-btn.png";
import IOS from "../../Assets/Images/ios-btn.png";
import { AnimatedOnScroll } from "react-animated-css-onscroll";
import SplashScreen from "../../Components/SplashScreen/splashScreen";
import SliderOne from "../../Assets/Images/slider-1.png";
import SliderTwo from "../../Assets/Images/slider-2.png";
import SliderThree from "../../Assets/Images/slider-3.png";

const Home = () => {
  const [open, setOpen] = useState(true);
  const [trackingId, setTrackingId] = useState();

  useEffect(() => {
    if(document.getElementById("splashscreen")) {
      document.getElementById("splashscreen").scrollTo(0, 0);
    }

    setTimeout(() => {
      setOpen(false);
    }, 3000);
  }, []);

  const handleChange = (event, key) => {
    event.preventDefault();
    setTrackingId(event.target.value);
  };
  const setTrackingInfo = (event) => {
    if(trackingId) {
      window.open(`http://intransit-test.s3-website.ap-south-1.amazonaws.com/order-tracking?trackingId=${trackingId}`)
      // window.open(`http://localhost:3002/order-tracking?trackingId=${trackingId}`)
    }
  }
  return (
    <>
      {open ? <SplashScreen /> : null}
      {/* <Header /> */}

      <div className="main-home">
        <div className="container">
          <div className="track-section">
            <h1 className="text-center">
              Track your orders. anytime. anywhere
            </h1>
            <div className="track-custom">
              <div className="form-group">
                <div className="label-custom">
                  <label>Tracking ID</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter tracking ID here"  onChange={(event) => handleChange(event, "trackingId")}
                  />
                </div>
                <button
                  className="yellow-btn"
                   onClick={(e)=> setTrackingInfo(e)}
                >
                  Start Tracking
                </button>
                {/* <div className="modal modal-common" id="myModal">
                  <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">add package</h5>
                        <span className="close" data-dismiss="modal">
                          <i class="fas fa-times"></i>
                        </span>
                      </div>

                      <div className="modal-body p-0">
                        <div className="add-form">
                          <div className="track-location-img">
                            <img src={MapImg} />
                          </div>
                          <div className="track-details-map">
                            <div className="track-detail-header">
                              <div className="postal-img">
                                <img src={PostalService} />
                              </div>
                              <p>
                                Order Status: <span>Shipped</span>
                              </p>
                            </div>

                            <div className="order-location-track">
                              <ul>
                                <li className="active">
                                  <p>Arrived at Post Office</p>
                                  <span>Dec 30, 02:15 PM</span>
                                </li>
                                <li>
                                  <p>Departed USPS Facility</p>
                                  <span>Dec 27, 16:13 PM</span>
                                </li>
                                <li>
                                  <p>Arrived at USPS Destination Facility</p>
                                  <span>Dec 27, 11:11 PM</span>
                                </li>
                                <li>
                                  <p>Order Picked up</p>
                                  <span>Dec 25, 07:35 AM</span>
                                </li>
                                <li>
                                  <p>Order Processed</p>
                                  <span>Dec 24, 12:00 AM</span>
                                </li>
                                <li>
                                  <p>Payment Confirmed</p>
                                  <span>Dec 23, 11:13 PM</span>
                                </li>
                                <li>
                                  <p>Order Placed</p>
                                  <span>Dec 23, 11:11 PM</span>
                                </li>
                              </ul>
                              <div className="home-p">
                                <p>
                                  Estimated Delivery: <span>Jan 13</span>
                                </p>
                                <p>
                                  Tracking: <span>#423456798764</span>
                                </p>
                                <button className="yellow-btn">
                                  Report an Issue
                                  <span>
                                    <i class="fas fa-chevron-circle-right"></i>
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="mask-img-start">
              <img src={MaskImg} />
            </div>
          </div>

          <section className="rating-section">
            <div className="row">
              <div className="col-md-12 col-lg-5">
                <div className="why-choose">
                  <AnimatedOnScroll
                    animationIn="slideInLeft"
                    animationInDuration={2000}
                  >
                    <div className="why-choose-head">
                      <p>What we do?</p>
                      <h6>
                        InTransit offers package protection and tracking
                        services for eCommerce merchants as well as customers.
                        Merchants can offer InTransit as a value-added service
                        to their customers every time they place an order. Users
                        can track their orders with live updates and insure
                        their package against issues like damage, theft, or
                        mislaid deliveries.
                      </h6>
                    </div>
                  </AnimatedOnScroll>

                  <AnimatedOnScroll
                    animationIn="slideInUp"
                    animationInDuration={2000}
                  >
                    <div className="rating-slider">
                      <div
                        id="demo"
                        className="carousel slide"
                        data-ride="carousel"
                        data-interval="false"
                        data-pause="hover"
                      >
                        <ul className="carousel-indicators">
                          <li
                            data-target="#demo"
                            data-slide-to="0"
                            className="active"
                          >
                            <p>01.</p>
                          </li>
                          <li data-target="#demo" data-slide-to="1">
                            <p>02.</p>
                          </li>
                          <li data-target="#demo" data-slide-to="2">
                            <p>03.</p>
                          </li>
                        </ul>

                        <div className="carousel-inner">
                          <div className="carousel-item active">
                            <div className="slider-img">
                              <img src={SliderOne} alt="Slider Image" />
                            </div>
                          </div>
                          <div className="carousel-item">
                            <div className="slider-img">
                              <img src={SliderTwo} alt="Slider Image" />
                            </div>
                          </div>
                          <div className="carousel-item">
                            <div className="slider-img">
                              <img src={SliderThree} alt="Slider Image" />
                            </div>
                          </div>
                        </div>

                        <div class="solution-alert-img">
                          <img src={MaskImgPhone} alt="mask image" />
                        </div>
                      </div>
                    </div>
                  </AnimatedOnScroll>
                </div>
              </div>
              <div className="col-md-12 col-lg-7">
                <div className="rating-desc">
                  <AnimatedOnScroll
                    animationIn="fadeInDown"
                    animationInDuration={2000}
                  >
                    <ul>
                      <li>
                        <div className="rating-number">
                          <div className="rating-img">
                            <img src={Star} />
                          </div>
                          <h4>4.2+ Rating</h4>
                          <p>Reviews</p>
                        </div>
                      </li>
                      <li>
                        <div className="rating-number">
                          <div className="rating-img">
                            <img src={Secure} />
                          </div>
                          <h4>Secure</h4>
                          <p>Security</p>
                        </div>
                      </li>
                      <li>
                        <div className="rating-number">
                          <div className="rating-img">
                            <img src={Support} />
                          </div>
                          <h4>Support</h4>
                          <p>1 min response</p>
                        </div>
                      </li>
                    </ul>
                  </AnimatedOnScroll>

                  <AnimatedOnScroll
                    animationIn="slideInRight"
                    animationInDuration={2000}
                  >
                    <div className="what-we">
                      <div className="what-we-head">
                        <p>Why Choose us?</p>
                        {/* <h4 className="mb-4">
                        Lorem ipsum Lorem ipsum sit, Lorem ipsum Lorem ipsum
                      </h4> */}
                      </div>
                      <div className="what-we-desc">
                        <p>
                          InTransit is a comprehensive post-purchase tracking
                          service for all your online deliveries. We ease the
                          process of secure and safe transit and ensure
                          customers get an exceptional experience each time they
                          make an online purchase.
                        </p>
                        <ul>
                          <li>Track</li>
                          <li>Protect</li>
                          <li>Engage</li>
                        </ul>
                      </div>
                    </div>
                  </AnimatedOnScroll>
                </div>
              </div>
            </div>
          </section>

          <section className="works-main">
            <div className="common-head">
              <div className="line-head">
                <p>Get a competitive edge with InTransit</p>
              </div>
              {/* <h4>Lorem ipsum dolor sit</h4> */}
            </div>
            {/* <p className="text-center">
            Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem
            ipsum Lorem ipsum.
          </p> */}

            <AnimatedOnScroll
              animationIn="slideInUp"
              animationInDuration={1000}
            >
              <ul>
                <li className="active">
                  <div className="works-desc">
                    <div className="proton-img">
                      <img src={ReImg} />
                    </div>
                    <h5>Live Tracking</h5>
                  </div>
                  <div className="proton-desc">
                    <div className="proton-img">
                      <img src={ReImg} />
                    </div>
                    <h5>Live Tracking using Geo-fencing</h5>
                    <p>
                      InTransit uses the state-of-the-art geofencing solution
                      for every order, allowing for intuitive and effective live
                      order tracking
                    </p>
                  </div>
                </li>
                <li>
                  <div className="works-desc">
                    <div className="proton-img">
                      <img src={ReImg} />
                    </div>
                    <h5>Real-time updates</h5>
                  </div>
                  <div className="proton-desc">
                    <div className="proton-img">
                      <img src={ReImg} />
                    </div>
                    <h5>Real-time updates</h5>
                    <p>
                      The geo-fencing tracking technology keeps the users in the
                      loop throughout the package journey, right from the
                      dispatch to the final delivery
                    </p>
                  </div>
                </li>
                <li>
                  <div className="works-desc">
                    <div className="proton-img">
                      <img src={ReImg} />
                    </div>
                    <h5>History</h5>
                  </div>
                  <div className="proton-desc">
                    <div className="proton-img">
                      <img src={ReImg} />
                    </div>
                    <h5>Order History</h5>
                    <p>
                      InTransit lets you keep track of every online purchase,
                      making it easier for the customer to know when, what and
                      where the order came from.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="works-desc">
                    <div className="proton-img">
                      <img src={ReImg} />
                    </div>
                    <h5>
                      Instant Query <br></br> Resolution
                    </h5>
                  </div>
                  <div className="proton-desc">
                    <div className="proton-img">
                      <img src={ReImg} />
                    </div>
                    <h5>Instant Query Resolution</h5>
                    <p>
                      We make sure any query or complaint related to order
                      delivery (lost, stolen and damaged packages) is pinpointed
                      and resolved almost instantly.
                    </p>
                  </div>
                </li>
              </ul>
            </AnimatedOnScroll>
          </section>

          {/* <section className="blog-section">
          <div className="common-head">
            <div className="line-head">
              <p>How it works?</p>
            </div>
            <h4>Lorem ipsum dolor sit</h4>
          </div>

          <div className="row">
            <div className="col-md-12 col-lg-6">
              <AnimatedOnScroll
                animationIn="slideInUp"
                animationInDuration={2000}
              >
                <div className="blog-group">
                  <div className="blog-img">
                    <img src={Blog} />
                  </div>
                  <div className="blog-desc">
                    <div className="blog-date">
                      <p>15 Dec.</p>
                    </div>
                    <div className="blog-query">
                      <h5>
                        Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor
                      </h5>
                      <p>
                        Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor
                        Lorem ipsum dolor Lorem ipsum dolor...{" "}
                        <span>Read More</span>
                      </p>
                    </div>
                  </div>
                </div>
              </AnimatedOnScroll>
            </div>
            <div className="col-md-12 col-lg-6">
              <AnimatedOnScroll
                animationIn="slideInRight"
                animationInDuration={2000}
              >
                <ul>
                  <li>
                    <div className="blog-sub-img">
                      <img src={Blog} />
                    </div>
                    <div>
                      <h5>Lorem ipsum dolor Lorem ipsum</h5>
                      <p>
                        Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor
                        Lorem ipsum dolor Lorem ipsum dolor...{" "}
                        <span>Read More</span>
                      </p>
                    </div>
                  </li>

                  <li>
                    <div className="blog-sub-img">
                      <img src={Blog} />
                    </div>
                    <div>
                      <h5>Lorem ipsum dolor Lorem ipsum</h5>
                      <p>
                        Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor
                        Lorem ipsum dolor Lorem ipsum dolor...{" "}
                        <span>Read More</span>
                      </p>
                    </div>
                  </li>

                  <li>
                    <div className="blog-sub-img">
                      <img src={Blog} />
                    </div>
                    <div>
                      <h5>Lorem ipsum dolor Lorem ipsum</h5>
                      <p>
                        Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor
                        Lorem ipsum dolor Lorem ipsum dolor...{" "}
                        <span>Read More</span>
                      </p>
                    </div>
                  </li>

                  <button className="yellow-btn">View More</button>
                </ul>
              </AnimatedOnScroll>
            </div>
          </div>
        </section> */}

          <section className="download-section">
            <AnimatedOnScroll
              animationIn="slideInLeft"
              animationInDuration={1000}
            >
              <div className="box-store-btn">
                <h2>Coming Soon!</h2>
                <div className="download-btn">
                  <div className="play-btn">
                    <img src={Android} />
                  </div>
                  <div className="play-btn">
                    <img src={IOS} />
                  </div>
                </div>
              </div>
            </AnimatedOnScroll>
          </section>
        </div>
      </div>
    </>
  );
};

export default Home;
